export const visit = (vm, at) => {
at({ "fi": { "uiAddonTeams": { "teamSelectLabelOne": "1 tiimi valittu", "teamSelectLabelMany": "{{ count }} tiimi\xE4 valittu", "selectTeams": "Valitse tiimit", "selectAll": "Valitse kaikki ({{ teamName }})" } } });
};